<template>
  <h1
    v-if="text"
    class="font-black text-[#2B2926] tracking-[-0.03em]"
    :class="titleClasses"
    v-html="formattedText"
    :data-blok-c="dataBlokC"
    :data-blok-uid="dataBlokUid"
  ></h1>
</template>

<script>
export default {
  name: 'ContentTitle',
  props: {
    text: {
      type: String,
      default: '',
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'large',
      validator: value => ['small', 'medium', 'large'].includes(value),
    },
    dataBlokC: {
      type: String,
      default: '',
    },
    dataBlokUid: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedText() {
      if (!this.text) return '';
      return this.isHtml ? this.text : this.escapeHtml(this.text);
    },
    titleClasses() {
      const sizeMap = {
        small: 'text-[1.5rem] leading-[2rem]',
        medium: 'text-[2rem] leading-[2.5rem]',
        large: 'text-[2.5rem] leading-[3rem] md:text-[3rem] md:leading-[3.5rem]',
      };
      return sizeMap[this.size] || sizeMap.large;
    },
  },
  methods: {
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter', 'aktiv-grotesk', sans-serif;
}

:deep(b),
:deep(strong) {
  font-weight: 900;
}

:deep(i),
:deep(em) {
  font-style: italic;
}

:deep(u) {
  text-decoration: underline;
}
</style>
